export const NAME = 'COMPLIANCE_LIST';

export const FETCH_START = `${NAME}/FETCH_START`;
export const FETCH_SUCCESS = `${NAME}/FETCH_SUCCESS`;
export const FETCH_FAIL = `${NAME}/FETCH_FAIL`;

export const RESET = `${NAME}/RESET`;
